import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import DPSubForm from "../dietPackage/DPSubForm";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import DietDays from "../dietPackage/DietDays";

const DaysTab = ({
  selectedDays,
  dpFormErrors,
  formValues,
  setFormValues,
  allFormValues,
  // mealCategories,
  isView,
  dpForm,
}) => {
  const { loading } = useSelector((state) => state.dropdown);

  const startDay = selectedDays.label.includes("-")
    ? Number(selectedDays.label.split("-")[0])
    : 1;

  const [selectedTab, setSelectedTab] = useState(startDay);
  const [dailyTotals, setDailyTotals] = useState([]);
  const [selectedCopyFrom, setSelectedCopyFrom] = useState("");

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setSelectedCopyFrom("");
  };

  function calculateDailyTotals(goalDiets) {
    const newDailyTotals = goalDiets?.map((day) => {
      const totals = {
        CARBS: 0,
        FAT: 0,
        PROTEIN: 0,
        TOTAL_CALORY: 0,
      };

      day?.forEach((mealTime) => {
        mealTime?.meals?.forEach((meal) => {
          const { totalCalory } = meal;
          totals.CARBS += totalCalory.carbs || 0;
          totals.FAT += totalCalory.fats || 0;
          totals.PROTEIN += totalCalory.protiens || 0;
          totals.TOTAL_CALORY += totalCalory.totalCal || 0;
        });
      });

      return totals;
    });

    setDailyTotals(newDailyTotals);
  }

  function checkDailyCalorie(cal) {
    const floatedCal = parseFloat(cal || 0);
    const floatedMinCal = parseFloat(dpForm?.minCal || 0);
    const floatedMaxCal = parseFloat(dpForm?.maxCal || 0);

    if (floatedCal < floatedMinCal) {
      return `recommended Calorie Should be in between ${floatedMinCal} to ${floatedMaxCal} cal`;
    } else if (floatedCal > floatedMaxCal) {
      return `recommended Calorie Should be in between ${floatedMinCal} to ${floatedMaxCal} cal`;
    } else {
      return;
    }
  }

  useEffect(() => {
    setSelectedTab(startDay);
    setSelectedCopyFrom("");
  }, [startDay]);

  useEffect(() => {
    calculateDailyTotals(allFormValues);
  }, [allFormValues, formValues, selectedTab]);

  return (
    <div
      className={`srollable-tabs srollable-tabs-fixed ${
        selectedDays.value <= 7 ? "w100P" : ""
      }`}
    >
      <Tabs>
        <TabList>
          {[...Array(selectedDays.value)].map((_, index) => (
            <Tab key={index} onClick={() => handleTabSelect(startDay + index)}>
              Day {startDay + index}
            </Tab>
          ))}
        </TabList>

        <div className="flex-end calorie-info mt30 mb30">
          {dailyTotals?.length > 0 && dailyTotals[selectedTab - 1] ? (
            <span
              className={`info calorie-info ${
                checkDailyCalorie(
                  dailyTotals[selectedTab - 1]?.TOTAL_CALORY?.toFixed(2) || 0
                )
                  ? "wrong-info"
                  : ""
              }  `}
              style={{
                borderRadius: "8px",
                fontWeight: "400",
              }}
            >
              Calorie -{" "}
              <b>
                {dailyTotals[selectedTab - 1]?.TOTAL_CALORY?.toFixed(2) || 0}
              </b>
              , carbs -{" "}
              <b>{dailyTotals[selectedTab - 1]?.CARBS?.toFixed(2) || 0}</b>,
              fats - <b>{dailyTotals[selectedTab - 1]?.FAT?.toFixed(2) || 0}</b>
              , protein -{" "}
              <b>{dailyTotals[selectedTab - 1]?.PROTEIN?.toFixed(2) || 0}</b>{" "}
              {checkDailyCalorie(
                dailyTotals[selectedTab - 1]?.TOTAL_CALORY?.toFixed(2) || 0
              ) ? (
                <sub>
                  (
                  {checkDailyCalorie(
                    dailyTotals[selectedTab - 1]?.TOTAL_CALORY?.toFixed(2) || 0
                  )}
                  )
                </sub>
              ) : null}
            </span>
          ) : null}
        </div>

        {[...Array(selectedDays.value)].map((_, index) => {
          return (
            <TabPanel key={index}>
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <>
                  {isView ? (
                    <DietDays formValues={formValues[index]} />
                  ) : (
                    <DPSubForm
                      dayNo={selectedTab - 1}
                      selectedDay={selectedDays}
                      formValues={formValues[index]}
                      setFormValues={setFormValues}
                      dpFormErrors={dpFormErrors}
                      allFormValues={allFormValues}
                      // mealCategories={mealCategories}
                      dailyTotals={dailyTotals[selectedTab - 1]}
                      planDuration={dpForm.planDuration}
                      selectedCopyFrom={selectedCopyFrom}
                      setSelectedCopyFrom={setSelectedCopyFrom}
                    />
                  )}
                </>
              )}
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
};

export default DaysTab;
